export default theme => ({
  editRoot: {
    padding: theme.spacing(0),
    zIndex: "2000",
    position: "fixed",
    height: "calc(100% - 80px)",
    right: "0px",
    top: "80px"
    //overflowY: "scroll"
  },
  editLeftSide: {
    position: "absolute",
    minWidth: "calc(100% - 559px)",
    minHeight: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)"
  },
  editRightSide: {
    maxWidth: "100%",
    width: "600px",
    boxShadow: "-2px 2px 4px 0 rgba(0, 0, 0, 0.1)",
    display: "flex",
    flexDirection: "column"
  },
  editCloseContainer: {
    display: "flex"
  },
  editCloseButton: {
    marginLeft: "auto",
    order: "2"
  },
  connectorTitle: {
    textTransform: "uppercase",
    color: theme.palette.text.secondary
  },
  editTitleRow: {
    display: "flex",
    flexDirection: "row"
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  subtitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.25),
    color: "#000"
  },
  intentDetails: {
    fontStyle: "italic",
    color: "#333"
  },
  intentDetailsBox: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
});
